import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import cn from 'classnames';
import Heading from 'components/shared/heading';
import List from './List';
import Accordion from './Accordion';
import styles from './styles.module.scss';

const FeaturesTabs = ({
  items = [],
  title = null,
  theme = null,
  description = null,
  reverseColumns = false,
}) => {
  // Desktop: >= 1024px (shows list layout), Mobile: < 1024px (shows accordion layout)
  // isClient guard ensures SSR and initial hydration render the same JSX (desktop/List),
  // preventing React hydration mismatch error #418.
  const [isClient, setIsClient] = useState(false);
  const isDesktop = useMedia('(min-width: 1024px)', true);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!items || items.length === 0) {
    return null;
  }

  // Render appropriate child component based on device size
  return (
    <section
      className={cn(styles.featuresList, {
        [styles.themeLight]: theme === 'light',
      })}
    >
      <div className={styles.inner}>
        <div className="container">
          {title && (
            <Heading className={styles.title} tag="h2" size="xl">
              {title}
            </Heading>
          )}
          {description && (
            <div className={styles.text} dangerouslySetInnerHTML={{ __html: description }} />
          )}

          {!isClient || isDesktop ? (
            <List items={items} reverseColumns={reverseColumns} />
          ) : (
            <Accordion items={items} />
          )}
        </div>
      </div>
    </section>
  );
};

FeaturesTabs.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      image: PropTypes.shape({
        id: PropTypes.number,
      }),
    })
  ),
  reverseColumns: PropTypes.bool,
};

export default FeaturesTabs;
